import { useEffect, useRef } from "react";

// 관리자 실시간 소켓(계약 §5). 빠른 길일 뿐이라 끊겨도 화면은 30초 요약 조회로 맞는다.
// 접속 뒤 첫 메시지로 직원 토큰을 보낸다(주소에 싣지 않는다). 4401 = 토큰 문제(다시 로그인), 4403 = 사용 중지·비밀번호 변경 전 — 둘 다 다시 붙지 않는다.
export const backoffDelay = (n) => Math.min(30000, 1000 * 2 ** n);
const CLOSE_UNAUTHORIZED = 4401;
const CLOSE_FORBIDDEN = 4403;

export default function useAdminSocket(token, onEvent, onAuthLost) {
    const handler = useRef(onEvent);
    handler.current = onEvent;
    const lost = useRef(onAuthLost);
    lost.current = onAuthLost;
    useEffect(() => {
        if (!token || !process.env.REACT_APP_API_URL) return undefined;
        let ws = null, tries = 0, timer = null, ping = null, stopped = false;
        const url = `${process.env.REACT_APP_API_URL.replace(/^http/, "ws")}/ws/admin`;
        const connect = () => {
            ws = new WebSocket(url);
            ws.onopen = () => { try { ws.send(JSON.stringify({ type: "auth", token })); } catch { /* 닫힘은 onclose 가 처리 */ } };
            ws.onmessage = (e) => {
                let msg;
                try { msg = JSON.parse(e.data); } catch { return; }
                if (msg.type === "ready") tries = 0;
                handler.current(msg);
            };
            ws.onclose = (ev) => {
                clearInterval(ping);
                if (stopped) return;
                if (ev?.code === CLOSE_UNAUTHORIZED) { stopped = true; lost.current?.(); return; }
                if (ev?.code === CLOSE_FORBIDDEN) { stopped = true; return; }
                timer = setTimeout(connect, backoffDelay(tries++));
            };
            ping = setInterval(() => { try { ws.send(JSON.stringify({ type: "ping" })); } catch { /* 끊김은 onclose가 처리 */ } }, 25000);
        };
        connect();
        return () => { stopped = true; clearTimeout(timer); clearInterval(ping); if (ws) ws.close(); };
    }, [token]);
}
